import { createContext } from 'react';
import IConfiguration from './IConfiguration';
const ConfigContext = createContext<Partial<IConfiguration>>({});
export default ConfigContext;